'use strict';

export default class ChampController
{
	/*@ngInject*/
	constructor($state, $stateParams, $log, $http)
	{
		//console.log("Champ: " + $stateParams.champ);
		//console.log("Category: " + $stateParams.category);
		this.active = 0;

		var route = "/api/frontend/champs/" + $stateParams.champ;
		if ($stateParams.category) route += "/" + $stateParams.category;

		$http.post(route)
		.then(response => 
		{ 
			this.data = response.data;
			this.active = $stateParams.category != null ? $stateParams.category : 0;

			if (this.data.results != null)
			{
				// Multiplicar las cabeceras, por el número de carreras
				//@{
				for (var i = 0; i < this.data.results.length; ++i)
				{
					var headers = [];
					for (var j = 0; j < this.data.results[i].races.length; ++j)
					{
						headers.push(null); // Space for points
						headers = headers.concat(this.data.extra);
					}

					this.data.results[i].headers = headers;
				}
				//@}
			}
		})
		.catch(() => {
			$state.go("home");
		});
	}

	OnTabChange(tabIndex)
	{
		//TODO: Change URL to reflect selected tab (category)
	}
}



// WEBPACK FOOTER //
// ./client/app/frontend/champs/champ.controller.js